import { FatalError, TypedError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalAssertReactiveError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Target is not a valid reactive object',
    'zh-CN': '目标不是合法的响应式对象',
    'zh-HK': '目標不是合法的反應式對象'
  }

  override name = 'FatalAssertReactiveError' as const

  constructor() {
    super()
  }
}

export function registerErrorsSideEffect() {
  TypedError.registerErrorLocales({
    FatalAssertReactiveError
  })
}

registerErrorsSideEffect()
